import { render, staticRenderFns } from "./OrderFabricKnitTypeTable.vue?vue&type=template&id=27e223a2&"
import script from "./OrderFabricKnitTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricKnitTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports